import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectItemActivitysReducer(state = initialState.projectItemActivitys, action) {

    const mergeInProjectItemActivity = (projectItemActivitys, projectItemActivityUpdate) => {    
        const projectItemActivitysMinusStaleData = projectItemActivitys.filter(projectItemActivity => projectItemActivity.id !== projectItemActivityUpdate.id);       
        return projectItemActivitysMinusStaleData.concat(projectItemActivityUpdate);
    }

     const deleteProjectItemActivity = (current, id) => {
        return current.filter(projectItemActivity => projectItemActivity.id !== id);
    } 


    switch (action.type) {
        case types.LOAD_PROJECTITEMACTIVITY_SUCCESS:
        case types.UPDATED_PROJECTITEMACTIVITY_SUCCESS:
            return mergeInProjectItemActivity(state, action.projectItemActivity);
            case types.DELETED_PROJECTITEMACTIVITY:      
            return deleteProjectItemActivity(state, action.projectItemActivity.id);      
        case types.DELETED_PROJECTITEMACTIVITY_INCOMING:  
        case types.UPDATED_PROJECTITEMACTIVITY_INCOMING:
            return deleteProjectItemActivity(state, action.payload.id);    
        default:
            return state;
    }
}

